import React from "react";
import createSvgIcon from "../utils/createSvgIcon";
export default createSvgIcon(React.createElement(React.Fragment, null, React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.0761 4.01988C15.811 3.70167 15.3381 3.65868 15.0198 3.92385L6.01984 11.4239C5.84885 11.5663 5.74998 11.7774 5.74998 12C5.74998 12.2226 5.84885 12.4337 6.01984 12.5762L15.0198 20.0762C15.3381 20.3414 15.811 20.2984 16.0761 19.9802C16.3413 19.662 16.2983 19.189 15.9801 18.9239L7.67152 12L15.9801 5.07618C16.2983 4.81101 16.3413 4.33809 16.0761 4.01988Z"
})), "IconChevronLeft");